import { AuthData, tryEnableMembership } from '../../connector/auth';
import { createUser } from '../../connector/api';
import { RestUser } from '../../schema-copy/api-schema';
import { AppContext } from '../../context/general';

// Post-confirmation sequence shared by ConfirmEmail, AcceptTerms and Login: the account is
// confirmed but has no app user yet — create it, enable the membership and switch the app to
// logged-in mode. Returns the logged-in user (e.g. so the caller can pick an anon-import path).
export async function finishConfirmedLogin(appState: AppContext, authData: AuthData): Promise<RestUser> {
  const user = await createUser(authData, 'user');
  const {authData: newAuthData, user: newUser} = await tryEnableMembership(authData, {memberId: user.id, teamId: user.teamId});
  const finalUser = newUser ?? user;
  appState.setLoggedIn(newAuthData, finalUser);
  return finalUser;
}
